module.exports = __webpack_public_path__ + "static/media/doc04.9efae9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc04.png
// module id = 56
// module chunks = 0